import { render, staticRenderFns } from "./ModuleRating.vue?vue&type=template&id=465579b1&scoped=true"
import script from "./ModuleRating.vue?vue&type=script&lang=js"
export * from "./ModuleRating.vue?vue&type=script&lang=js"
import style0 from "./ModuleRating.vue?vue&type=style&index=0&id=465579b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465579b1",
  null
  
)

export default component.exports